import { z } from 'zod';

export const eligibilityPostResponseSchema = z.object({
  data: z.object({ answer: z.string().optional(), problem_params: z.string().optional() }),
  response: z.object({ date: z.string(), messages: z.array(z.string()), status: z.number(), type: z.string() }),
});
